<template>
  <div>
    <v-card class="mb-4">
      <v-card-text>
        <v-tabs
          v-model="standardUsageTab"
          background-color="transparent"
          color="primary"
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          class="mb-4"
          @change="handleStandardUsageTabChange"
        >
          <v-tab
            v-for="tab in standardUsageTabs"
            :key="tab.name"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="standardUsageTab">
          <v-tab-item
            v-for="tab in standardUsageTabs"
            :key="tab.name"
            :eager="true"
          >
            <component
              :is="tab.component"
              :faq="faq"
              :loader-script-url="loaderScriptUrl"
              :hosted-url="hostedUrl"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <p class="text-h6 pt-6">
      {{ $t('Other ways of using your FAQ') }}
    </p>

    <v-card>
      <v-card-text>
        <v-tabs
          v-model="otherUsageActiveTab"
          background-color="transparent"
          color="primary"
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          class="mb-4"
        >
          <v-tab
            v-for="tab in otherUsageTabs"
            :key="tab.name"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="otherUsageActiveTab">
          <v-tab-item
            v-for="tab in otherUsageTabs"
            :key="tab.name"
            :eager="true"
          >
            <component
              :is="tab.component"
              :faq="faq"
              :hosted-url="hostedUrl"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Embed from '@/components/publish/Embed';
import Widget from '@/components/publish/Widget';
import Portal from '@/components/publish/Portal';
import ShareViaUrl from '@/components/publish/ShareViaUrl';
import IntegrateViaApi from '@/components/publish/IntegrateViaApi';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';

export default {
 layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'publish',
      faq: page.data.props.faq
    }
  }, [page])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    scriptUrls: {
      type: Object,
      required: true
    },
    hostedUrl: {
      type: String,
      required: true
    },
    loaderScriptUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      standardUsageTab: 0,
      otherUsageActiveTab: 0
    }
  },

  computed: {
    standardUsageTabs() {
      return [
        { name: this.$t('Embed on page'), component: Embed, key: 'embed' },
        { name: this.$t('Use as widget'), component: Widget, key: 'widget' },
        { name: this.$t('FAQ Portal'), component: Portal, key: 'portal' },
      ];
    },

    otherUsageTabs() {
      return [
        { name: this.$t('Share via URL'), component: ShareViaUrl },
        { name: this.$t('Integrate via API'), component: IntegrateViaApi },
      ];
    },
  },

  created() {
    this.$root.preview.faq.component = 'embed';
  },

  methods: {
    handleStandardUsageTabChange(index) {
      const tab = this.standardUsageTabs[index];
      if (tab && tab.key) {
        this.$root.preview.faq.component = tab.key;
      }
    }
  }
}
</script>